// extracted by mini-css-extract-plugin
module.exports = {"Inputs":"Card_Inputs__2_EuC","Card":"Card_Card__2MtnA","fadeIn":"Card_fadeIn__2NUmI","modalFadeIn":"Card_modalFadeIn__JSot-","slideInFromRight":"Card_slideInFromRight__pxpna"};